import React, { useEffect, useRef, useState } from "react";
import cross from "../../assets/images/cross.png";
import { Modal } from "flowbite-react";
import ResetPassword from "./ResetPassword";
import axios from "axios";
import { toast } from "react-toastify";

function Recovery(props) {
  const {
    openModal,
    setOpenModal,
    openRecoveryModal,
    setOpenRecoveryModal,
    openResetPasswordModal,
    setOpenResetPasswordModal,
    email,
  } = props;
  const [otp, setOtp] = useState(["", "", "", ""]); // Array to store OTP digits
  const inputRefs = useRef([]); // Ref to store input element references
  const [error, setError] = useState();

  const handleInputChange = (index, value) => {
    setError("");

    // If it's the last digit, only hold a single character
    if (index === 3) {
      setOtp((prevOtp) => {
        const newOtp = [...prevOtp];
        newOtp[index] = value.slice(0, 1);
        return newOtp;
      });
    } else {
      setOtp((prevOtp) => {
        const newOtp = [...prevOtp];
        newOtp[index] = value;
        return newOtp;
      });
    }

    // Focus on next input field if available
    if (value !== "" && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (
      (e.key === "Backspace" && otp[index] === "") ||
      (e.key === "delete" && otp[index] === "")
    ) {
      // Handle backspace when input is empty
      e.preventDefault();
      if (index > 0) {
        inputRefs.current[index - 1].focus();
      }
    }
  };

  const handleKeyDownEvent = (event) => {
    if (event.key === "Enter") {
      handleverifycode();
    }
  };
  
  const otpString = otp.join(""); // Convert array to string
  const handleverifycode = async () => {
    axios
      .post("https://aipricingtool-python.onrender.com/verify_recovery_code", {
        code: otpString,
      })
      .then((response) => {
        console.log(response.data);
        toast.success("OTP Successfull ");
        setOpenResetPasswordModal(true);
      })
      .catch((error) => {
        console.log(error);
        setError("Your OTP is Invalid Or Expired create a New One?");
      });
  };

  return (
    <>
      <Modal
        show={openRecoveryModal}
        onClose={() => setOpenRecoveryModal(false)}
        className="dashboard-modal bg-opacity-60"
        size="2xl"
      >
        <Modal.Body className="large">
          <div className="">
            <div className="sign_up px-5 md:px-0 flex justify-center items-center md:items-stretch lg:items-center  flex-col md:flex-row 2xl:py-[20px] ">
              <div className="sign_up_right_modal rounded-3xl w-full">
                <div className="cross w-full flex justify-end cursor-pointer">
                  <img
                    onClick={() => setOpenRecoveryModal(false)}
                    src={cross}
                    alt=""
                  />
                </div>
                <div className="max-w-[342px] m-auto text-center md:h-auto mb-5 lg:mb-6  2xl:mb-[68px]">
                  <h1 className="text-[27px] Campton-light pb-[18px]">
                    Account Recovery
                  </h1>
                  <p className="text-[#8D8D8D] text-sm Campton-thin ">
                    To help keep your account safe, we want to make sure that
                    it’s really you trying to sign in
                  </p>
                </div>
                <div className="form-container flex flex-col gap-3 md:gap-4 2xl:gap-8  ">
                  <div className="max-w-[260px] m-auto text-center">
                    <h1 className="text-lg Campton-light ">
                      Enter 4 Digits Code
                    </h1>
                    <p className="text-[#8D8D8D] text-[16px] Campton-thin">
                      Enter the 4 digits code that you received on your email.
                    </p>
                  </div>

                  <div className="flex gap-6 m-auto">
                    {otp.map((digit, index) => (
                      <div
                        key={index}
                        className="pin w-[50px] h-[55px] md:w-[70px] md:h-[77px] bg-[#F6F6F6] border border-[#D76E3E] rounded-xl p-[10px] md:p-[18px] "
                      >
                        <input
                          ref={(ref) => (inputRefs.current[index] = ref)}
                          className="font-semibold text-2xl w-full h-full focus:outline-none bg-transparent"
                          value={digit}
                          onChange={(e) =>
                            handleInputChange(index, e.target.value)
                          }
                          onKeyDown={(e) => {
                            handleKeyDown(e, index);
                            handleKeyDownEvent(e);
                          }}
                          maxLength={1}
                        />
                      </div>
                    ))}
                  </div>
                  {error && (
                    <>
                      <div onClick={() => setOpenRecoveryModal(false)}>
                        <p className="text-[#ff6839] text-center  text-sm mt-3 cursor-pointer hover:underline hover:underline-offset-2">
                          {error}
                        </p>
                      </div>
                    </>
                  )}
                  <div className="mt-[42px]">
                    <div
                      onClick={() => handleverifycode()}
                      className="btn_bg_gradient logout Campton lg:text-xl p-2 md:p-3 2xl:p-5 2xl:text-2xl"
                    >
                      Continue
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <ResetPassword
        openModal={openModal}
        setOpenModal={setOpenModal}
        openRecoveryModal={openRecoveryModal}
        setOpenRecoveryModal={setOpenRecoveryModal}
        openResetPasswordModal={openResetPasswordModal}
        setOpenResetPasswordModal={setOpenResetPasswordModal}
        email={email}
        otpString={otpString}
      />
    </>
  );
}

export default Recovery;
